import { ILatLon, IMapPoint, IPoiSearch, ISearchResult } from '../interfaces';

export class SearchResult implements ISearchResult {
  name: string;
  type: ISearchResult['type'];
  coordinates: ILatLon;
  poi?: IPoiSearch;
  mapPoint?: IMapPoint;
  price?: number;

  constructor(data?: ISearchResult) {
    if (data) {
      this.setData(data);
    }
  }

  setData(data: ISearchResult): void {
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any)[key] = (data as any)[key];
      }
    }
  }

  getName(): string {
    return this.name || 'Unidentified Site';
  }
}
